var exports = {
  "R": "FriendsList.module__friendsListContainer___TWVSMm",
  "X": "FriendsList.module__scroller___TWVSMm",
};

module.exports = exports;
